// @flow

import _ from 'lodash';

import ArrayUtils from '../../utils/ArrayUtils';
import StringUtils from '../../utils/StringUtils';

import ApiObject from '../ApiObject';
import OrderProduct from './OrderProduct';
import RestaurantMenu from '../menu/RestaurantMenu';
import Menu from '../menu/Menu';
import MenuPart from '../menu/MenuPart';

export default class OrderMenuPart extends ApiObject {

  id: string;

  name: string;

  products: Array<OrderProduct> = [];

  postJsonAssignation(data: Object) {
    this.products = [];
    _.each(data.products, (productData) => {
      const orderProduct:OrderProduct = new OrderProduct();
      orderProduct.fromJson(productData);
      this.products.push(orderProduct);
    });
  }

  fromMenuPart(menuPart: MenuPart) {
    this.id = menuPart.id;
    this.name = menuPart.name;
    return this;
  }

  //
  //
  //

  isValidWithRestaurantMenu(restaurantMenu: RestaurantMenu, menuId: string): boolean {
    const menu: Menu = restaurantMenu.getMenuWithId(menuId);
    const menuPart: MenuPart = menu.getPartWithId(this.id);

    const quantityMin = menuPart.min;
    const quantityMax = menuPart.max;

    if (this.products.length < quantityMin || this.products.length > quantityMax) {
      return false;
    }

    let res = true;
    _.each(this.products, (product: OrderProduct) => {
      if (!product.isValidWithRestaurantMenu(restaurantMenu)) {
        res = false;
        return false; // quit loop
      }
    });

    return res;
  }

  //
  //
  //

  equals(other: OrderProduct): boolean {
    return this.id === other.id && this.productsEquals(other.products);
  }

  productsEquals(otherProducts): boolean {
    if (otherProducts.length !== this.products.length) {
      return false;
    }

    // TODO: Handle not same order.
    for (let i = 0; i < this.products.length; i++) {
      if (!this.products[i].equals(otherProducts[i])) {
        return false;
      }
    }

    return true;
  }

  //
  //
  //

  getDescription(): string {
    let description = '';
    const separator = ', ';

    _.each(this.products, (product: OrderProduct) => {
      description += product.name + separator;
    });

    // remove last separator.
    return description.substring(0, description.length - separator.length);
  }

  getProductsComment(): string {
    let comment = '';
    const separator = ', ';

    _.each(this.products, (product: OrderProduct) => {
      if (!_.isEmpty(product.comment)) {
        comment += product.comment + separator;
      }
    });

    // remove last separator.
    return StringUtils.removeAtEnd(comment, separator);
  }

  getDescriptionWithProductComments(): string {
    let description = '';
    const separator = ', ';

    _.each(this.products, (product: OrderProduct) => {
      description += product.name;
      if (!_.isEmpty(product.comment)) {
        description += ` (${product.comment})`;
      }
      description += separator;
    });

    // remove last separator.
    return description.substring(0, description.length - separator.length);
  }

  getProductsWithCommentArray(): Array {
    const productsWithComment = [];

    _.each(this.products, (product: OrderProduct) => {
      productsWithComment.push({
        productName: product.name,
        comment: product.comment,
        product: product
      });
    });

    return productsWithComment;
  }

  //
  //
  //

  getTotalAdditionnalPrice(): number {
    let total = 0;
    _.each(this.products, (orderProduct: OrderProduct) => {
      total += orderProduct.getTotalAdditionnalPriceForMenu();
    });
    return total;
  }

  //
  //
  //

  addProduct(orderProduct: OrderProduct) {
    this.products.push(orderProduct);
  }

  updateProduct(orderProduct: OrderProduct) {
    this.products = ArrayUtils.updateObject(this.products, { id: orderProduct.id });
  }

  removeProductWithId(orderProductId: string) {
    this.products = ArrayUtils.removeObject(this.products, { id: orderProductId });
  }

  getProductById(productId: string): boolean {
    return ArrayUtils.find(this.products, { id: productId });
  }

  haveProductWithId(productId: string): boolean {
    return ArrayUtils.exists(this.products, { id: productId });
  }

}



// WEBPACK FOOTER //
// ./sdk/scripts/entities/order/OrderMenuPart.js